import { Anchor, Box, Button, Input, Select, Textarea } from "@mantine/core";
import { IconMail, IconSearch, IconUser } from "@tabler/icons-react";
import { apiUserGetCompany, apiUserPostDepartment } from "@/api";
import { useEffect, useState } from "react";

import { Badge } from "antd";
import Card from "@/components/Card";
import { useData } from "@/utility/state/contextAPI";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

function AddDepartmentListPage() {
  const { t } = useTranslation();
  const [currentStage, setCurrentStage] = useState(0);
  const [departmentData, setDepartmentData] = useState({
    code: "",
    workContent: "",
    name: "",
    company: localStorage.getItem("companyId"),
    leaders: [],
    members: [],
  });

  const [tempLeaderData, setTempLeaderData] = useState([]);
  const [tempMemberData, setTempMemberData] = useState([]);

  //當前已經選擇的資料
  const [leaderList, setLeaderList] = useState([]);
  const [memberList, setMemberList] = useState([]);

  // 可以選擇的資料
  const [memberData, setMemberData] = useState([]);
  const [leaderData, setLeaderData] = useState([]);
  const {
    modal: { contextOpenModal, contextCloseModal, contextSetModalContent },
  } = useData();
  const navigate = useNavigate();

  const { code, workContent, name, company, leaders, members } =
    departmentData || {};

  const handleRemoveMember = (member, members, setState) => {
    let newMemberData = members.filter(
      (currMember) => currMember.id !== member.id,
    );
    setState(newMemberData);
  };

  const handleDataChange = (name, value) => {
    setDepartmentData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleDisplayMembers = (members, setState) => {
    if (!members?.length) {
      return "";
    }

    return members.map((member) => (
      <div className="m-2">
        <Badge
          count="━"
          style={{ cursor: "pointer" }}
          onClick={() => handleRemoveMember(member, members, setState)}
        >
          <Card
            customStyle={{
              baseStyle: { margin: "0rem", width: "200px", height: "120px" },
            }}
            props={member}
          />
        </Badge>
      </div>
    ));
  };

  const handleSearchMembers = async (value, leaderData, setState) => {
    let match = value.match(/ID:\s*(\d+)/);
    let idNumber = match ? match[1] : null;

    let selectedData = leaderData.filter((e) => e?.id == idNumber)[0];

    if (selectedData) {
      setState(selectedData);
    } else {
      console.error("handleSearchMembers");
    }
  };

  const handleConfirmLeader = (leaderList, tempLeaderData, setState) => {
    let isInTheList = leaderList.some((t) => t.id == tempLeaderData.id);
    if (!isInTheList) {
      setState([...leaderList, tempLeaderData]);
    }
  };

  const handleSubmit = async ({ data }) => {
    try {
      let result = await apiUserPostDepartment({ data });

      if (result?.data) {
        setCurrentStage(1);
      } else {
        setCurrentStage(1);
      }
    } catch (error) {
      console.error("Error post department data:", error);
    }
  };

  const handleDisplaySelectMembers = (data) => {
    return data.map((t) => t?.name + ` (ID: ${t?.id})`);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        let id = localStorage.getItem("companyId");
        let result = await apiUserGetCompany({ id });
        if (result?.data) {
          let employees = result?.data?.employees;

          setMemberData(employees);
          setLeaderData(employees);
        }
      } catch (error) {
        console.error("Error fetching department data:", error);
      }
    };

    fetchData();
  }, []);
  return currentStage === 0 ? (
    <div className="flex  h-full items-center justify-center p-8">
      <div className="w-[765px] rounded-xl bg-white p-14">
        <>
          <div className="py-3 text-6xl font-bold" style={{ color: "#6F6F6F" }}>
            新增部門
          </div>
          <div className="flex">
            <div>
              <div
                className="py-3 text-2xl font-bold"
                style={{ color: "#6F6F6F" }}
              >
                部門名稱
              </div>
              <Input
                value={name}
                onChange={({ target: { value } }) =>
                  handleDataChange("name", value)
                }
                placeholder="Pick value"
              />
            </div>
            <div className="pl-3">
              <div
                className="py-3 text-2xl font-bold"
                style={{ color: "#6F6F6F" }}
              >
                部門代號
              </div>
              <Input
                value={code}
                onChange={({ target: { value } }) =>
                  handleDataChange("code", value)
                }
                placeholder="Pick value"
              />
            </div>
          </div>

          <div className="py-4">
            <div
              className="py-3 text-2xl font-bold"
              style={{ color: "#6F6F6F" }}
            >
              部門描述
            </div>
            <Textarea
              value={workContent}
              onChange={({ target: { value } }) =>
                handleDataChange("workContent", value)
              }
              placeholder="Input placeholder"
            />
          </div>

          <div className="py-8">
            <div className="text-2xl font-bold" style={{ color: "#6F6F6F" }}>
              部門主管
            </div>
            <div>
              <div className="flex">
                <Select
                  placeholder="輸入主管姓名"
                  data={handleDisplaySelectMembers(leaderData)}
                  leftSection={<IconSearch size={16} />}
                  onChange={(e) =>
                    handleSearchMembers(e, leaderData, setTempLeaderData)
                  }
                />
                <Button
                  variant="filled"
                  color="gray"
                  style={{ width: "100%", margin: "1rem", maxWidth: "100px" }}
                  radius="md"
                  onClick={() =>
                    handleConfirmLeader(
                      leaderList,
                      tempLeaderData,
                      setLeaderList,
                    )
                  }
                >
                  新增
                </Button>
              </div>
              <div className="grid grid-cols-1 gap-3 md:grid-cols-3">
                {handleDisplayMembers(leaderList, setLeaderList)}
              </div>
            </div>
          </div>
          <div className="py-8">
            <div className="text-2xl font-bold" style={{ color: "#6F6F6F" }}>
              部門成員
            </div>
            <div>
              <div className="flex">
                <Select
                  placeholder="輸入成員姓名"
                  data={handleDisplaySelectMembers(memberData)}
                  leftSection={<IconSearch size={16} />}
                  onChange={(e) =>
                    handleSearchMembers(e, memberData, setTempMemberData)
                  }
                />
                <Button
                  variant="filled"
                  color="gray"
                  style={{ width: "100%", margin: "1rem", maxWidth: "100px" }}
                  radius="md"
                  onClick={() =>
                    handleConfirmLeader(
                      memberList,
                      tempMemberData,
                      setMemberList,
                    )
                  }
                >
                  新增
                </Button>
              </div>
              <div className="grid grid-cols-1 gap-3 md:grid-cols-3">
                {handleDisplayMembers(memberList, setMemberList)}
              </div>
            </div>
          </div>
          <div className="flex">
            <Button
              variant="default"
              style={{ width: "100%", margin: "1rem" }}
              radius="md"
              onClick={() => navigate("/hrMainPage/department")}
            >
              {t("hrMain.cancel") || "取消"}
            </Button>
            <Button
              variant="filled"
              color="gray"
              style={{ width: "100%", margin: "1rem" }}
              radius="md"
              onClick={() =>
                handleSubmit({
                  data: {
                    ...departmentData,
                    leaders: leaderList?.map((t) => t.documentId),
                    members: memberList?.map((t) => t.documentId),
                    company: localStorage.getItem("companyId"),
                  },
                })
              }
            >
              新增
            </Button>
          </div>
        </>
      </div>
    </div>
  ) : (
    <div className="flex min-h-screen h-full items-center justify-center p-14 text-center">
      <div className="w-[487px] rounded-xl bg-white p-8">
        <div style={{ color: "#6F6F6F" }}>
          {t("hrMain.createDepartmentSuccess") || "建立部門成功！"}
        </div>
        <Button
          variant="filled"
          color="gray"
          style={{ width: "100%", margin: "1rem 0" }}
          radius="md"
          onClick={() => navigate("/hrMainPage/department")}
        >
          {t("hrMain.confirm") || "確定"}
        </Button>
      </div>
    </div>
  );
}
export default AddDepartmentListPage;
